import { render, staticRenderFns } from "./EditSessionsModal.vue?vue&type=template&id=771a8452&"
import script from "./EditSessionsModal.vue?vue&type=script&lang=js&"
export * from "./EditSessionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports